import OfflineSvg from "./offline/OfflineSvg";
import { RetryButton } from "./offline/retryBtn";

export default function CookiesBlockedPage() {
  return (
    <main className="offline-container">
      <div className="content">
        <div className="imageWrapper">
          <OfflineSvg />
        </div>
        <h2 className="title">
          <span className="oops">Oops!</span> Cookies or Storage Blocked
        </h2>
        <p className="message">
          It seems like cookies or local storage are disabled. Please enable
          them in your browser settings and disable any extensions that might
          interfere, then try again.
        </p>
        <RetryButton />
      </div>
    </main>
  );
}
